<template>
    <nav class="octolo-menu bg h-[60px] flex items-center justify-between sticky top-0">
        <div class="flex items-center">
            <slot name="left"></slot>
            <Logo class="pl-2.5" :link="link" :logo="logo" v-if="logo" />
        </div>
        <slot></slot>
        <slot name="right"></slot>
    </nav>
</template>

<script>
import Logo from '@/toremove/components/menu/Logo.vue';

export default {
    name: 'menu-octolo',
    components: { Logo },
    props: {
        logo: { type: String, default: '/static/img/LOGO-OCTOLO-H-NEW.svg' },
        link: { type: String, default: '/' }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";

.octolo-menu {
    border-bottom: 1px solid nth($octo-grayn, 22);
    z-index: 50;
    background-color: white;
    color: $octo-primary;
}
</style>
